import React from 'react';
import { useTheme } from 'styled-components';
import { ProgressBarVariantType } from '../../../theme/type/progress-bar-type';

type ProgressBarProps = {
    value: number;
    variant?: ProgressBarVariantType;
    startValue?: React.ReactNode;
    endValue?: React.ReactNode;
};

export const ProgressBar: React.FC<ProgressBarProps> = ({
    value = 0,
    variant = 'positive',
    startValue,
    endValue,
}: ProgressBarProps) => {
    const theme = useTheme();
    const progressVariant = theme.progressBar.variant[variant];

    return (
        <div className="relative flex w-full flex-col">
            <div
                className="relative flex h-[1.4rem] w-full items-center overflow-hidden rounded-[10rem]"
                style={{ backgroundColor: progressVariant.background }}
            >
                <div
                    className="absolute left-0 h-full max-w-full rounded-[10rem]"
                    style={{ width: `${value}%`, backgroundColor: progressVariant.bar }}
                />
            </div>
            {startValue && endValue && (
                <div className="mt-xsmall flex flex-wrap justify-between gap-xsmall">
                    <div>{startValue}</div>
                    <div className="ml-auto text-right">{endValue}</div>
                </div>
            )}
        </div>
    );
};
